import {applyMiddleware, createStore} from "redux";
import thunkMiddleware from 'redux-thunk';
import {composeWithDevTools} from 'redux-devtools-extension';
import rootReducer from './reducers/rootReducer';
import {createLogger} from "redux-logger";


//const store = createStore(rootReducer, {}, applyMiddleware(thunkMiddleware));
const store = createStore(rootReducer, {}, composeWithDevTools(applyMiddleware(thunkMiddleware, createLogger())));


export default store;